module.exports = __webpack_public_path__ + "dropify.4e8b017aef78cc114006.eot";


//////////////////
// WEBPACK FOOTER
// F:/SVNNew/Web/Phoenix HealthCare/HealthCare_UI/src/assets/vendors/by_bower/dropify/dist/fonts/dropify.eot
// module id = ../../../../../src/assets/vendors/by_bower/dropify/dist/fonts/dropify.eot
// module chunks = styles